const PodacastVideoBoxLoading = () => {
    return (
        <div className="l-load rounded-md p-4 mb-3">
            <div className="h-auto w-full gap-4 p-4" style={{ display: 'flex' }}>
                <div className="size-24 rounded-md l-load-dt"></div>
                <div className="space-y-2 flex-col" style={{ display: 'flex' }}>
                    <div className="w-48 h-4 l-load-dt"></div>
                    <div className="w-40 h-4 l-load-dt"></div>
                    <div className="w-32 h-4 l-load-dt"></div>
                </div>
            </div>
            <div className="w-full space-y-2">
                {[...Array(4)].map((_, i) => (
                    <div key={i} className={`w-full h-3 l-load-dt`}></div>
                ))}
            </div>
        </div>
    )
};
export default PodacastVideoBoxLoading;